import styled from 'styled-components';

const UserWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 56px;
    height: 32px;
`;

const DropdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 300px;
    width: fit-content;
    background: ${(props) => props.theme.colors.background_dashboard};
    box-shadow: ${(props) => props.theme.shadows.dropdown};
    border-radius: 12px 0px 12px 12px;
    padding: 16px;
    font-size: 13px;

    .notifications-settings {
      float: right;
      opacity: 0.4;
      transition: opacity 0.5s ease;

      &:hover {
        opacity: 1;
      }

      &.disabled {
        opacity: 0.2;
        pointer-events: none;
      }
    }

    .notifications-content {
      max-height: 500px;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 4px;
      }
  
      &::-webkit-scrollbar-track {
        background: none;
      }
  
      &::-webkit-scrollbar-thumb {
        background-color: ${(props) => props.theme.colors.inactive};
        border-radius: 100px;
        border: 10px solid ${(props) => props.theme.colors.white};
      }
    }

    .no-notifications {
      text-align: center;
      color: ${(props) => props.theme.colors.inactive};
      margin: 15px 0;
      cursor: default;
    }

    .notifications-header {
      font-size: 16px;
      margin-bottom: 16px;
      cursor: default;
    }

    .notifications-mark-all {
      color: ${(props) => props.theme.colors.green};
      text-align: right;
      margin-bottom: 16px;
    }

    .notification-item {
      margin-bottom: 16px;
      margin-right: 8px;
      background: ${(props) => props.theme.colors.widget_background};
      border-radius: 12px;
      padding: 12px;
      display: flex;
      cursor: pointer;
      width: calc(100% - 8px);

      .notification-thumbnail {
        width: 22px;
        height: 22px;
        margin-right: 8px;
        background: ${(props) => props.theme.colors.orange};
        border-radius: 6px;
      }
      
      .notification-icon {
        width: 22px;
        height: 22px;
        margin-right: 8px;
        background: ${(props) => props.theme.colors.orange};
        border-radius: 6px;
        padding: 4px;
        svg {
          path {
            fill: ${(props) => props.theme.colors.widget_background};
          }
        }
      }
      .notification-body {
        .notification-title {
          line-height: normal;
        }

        .notification-text {
          color: ${(props) => props.theme.colors.inactive};
          line-height: normal;
          margin: 4px 0;
          max-heigth: 100px;
        }

        .notification-date {
          color: ${(props) => props.theme.colors.inactive};
          line-height: normal;
        }

        .notification-tag {
          margin: 5px 0;
        }
        
        .notification-label {
          white-space: pre-line;
        }
      }

    }
`;

export default { UserWrapper, DropdownWrapper };
